import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { adminMe } from '../../lib/api';

export default function AdminProtected({ children }) {
  const [state, setState] = useState('loading'); // loading | ok | bad
  useEffect(() => {
    if (!localStorage.getItem('bs_admin_token')) { setState('bad'); return; }
    adminMe().then(() => setState('ok')).catch(() => {
      localStorage.removeItem('bs_admin_token');
      setState('bad');
    });
  }, []);
  if (state === 'loading') {
    return <div className="min-h-screen flex items-center justify-center bg-[var(--navy)] text-white font-tag opacity-70">Loading…</div>;
  }
  if (state === 'bad') return <Navigate to="/admin/login" replace />;
  return children;
}
